module.exports = __webpack_public_path__ + "img/logo.f029a413.svg";